import type { ReactElement } from "react";

// Line icons from the demo (24x24, stroked with currentColor by the surrounding CSS).
const P = (d: string) => <path d={d} />;
const IC: Record<string, ReactElement> = {
  check: P("M5 12.5l4.2 4.2L19 7"),
  up: P("M12 19V5M6 11l6-6 6 6"),
  down: P("M12 5v14M6 13l6 6 6-6"),
  in: P("M3 12h7M7 8l4 4-4 4M21 12h-7M17 8l-4 4 4 4"),
  out: P("M10 12H3M6 8l-4 4 4 4M14 12h7M18 8l4 4-4 4"),
  dot: <circle cx="12" cy="12" r="3" />,
  x: P("M6 6l12 12M18 6L6 18"),
  clock: (<><circle cx="12" cy="12" r="8" /><path d="M12 8v4l3 2" /></>),
  bag: (<><path d="M5 8h14l-1 12H6L5 8z" /><path d="M9 8a3 3 0 0 1 6 0" /></>),
  scissors: (<><circle cx="6" cy="7" r="2.5" /><circle cx="6" cy="17" r="2.5" /><path d="M8 8.5L20 17M8 15.5L20 7" /></>),
  ret: (<><path d="M9 7L4 12l5 5" /><path d="M4 12h11a5 5 0 0 1 0 10h-2" /></>),
  swap: P("M4 8h14l-3-3M20 16H6l3 3"),
  heart: P("M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"),
  ruler: (<><rect x="2.5" y="8" width="19" height="8" rx="1" /><path d="M6 8v3M9.5 8v4M13 8v3M16.5 8v4" /></>),
  link: (<><path d="M10 14a4 4 0 0 0 5.6 0l3-3a4 4 0 0 0-5.6-5.6l-1 1" /><path d="M14 10a4 4 0 0 0-5.6 0l-3 3a4 4 0 0 0 5.6 5.6l1-1" /></>),
  scale: (<><path d="M12 4v16M6 20h12M5 8h14" /><path d="M5 8l-3 6a3 3 0 0 0 6 0zM19 8l-3 6a3 3 0 0 0 6 0z" /></>),
  spark: P("M12 3v5M12 16v5M3 12h5M16 12h5M6 6l3 3M15 15l3 3M18 6l-3 3M9 15l-3 3"),
  price: (<><path d="M3 12V4h8l10 10-8 8z" /><circle cx="7.5" cy="8.5" r="1.3" /></>),
  meh: (<><circle cx="12" cy="12" r="9" /><path d="M8.5 15h7M9 10h.01M15 10h.01" /></>),
  chair: P("M7 3v10h10M7 13v8M17 13v8M7 9h9"),
  unbutton: (<><circle cx="12" cy="12" r="3" /><path d="M3 12h4M17 12h4M12 3v3M12 18v3" /></>),
  fabric: P("M4 6c3-2 5 2 8 0s5 2 8 0M4 12c3-2 5 2 8 0s5 2 8 0M4 18c3-2 5 2 8 0s5 2 8 0"),
  eye: (<><path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z" /><circle cx="12" cy="12" r="3" /></>),
  waist: P("M5 5h14M6 5l2 15M18 5l-2 15M10 8h4"),
  taper: P("M7 3l3 18M17 3l-3 18"),
  plus: P("M12 5v14M5 12h14"),
  you: (<><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /></>),
  mirror: (<><rect x="6" y="2.5" width="12" height="16" rx="6" /><path d="M12 18.5V22M8 22h8M9.5 7.5l3-3M9.5 11l5-5" /></>),
};

export function hasIcon(name: string | null | undefined): boolean {
  return !!name && name in IC;
}

export function Icon({ name }: { name: string | null | undefined }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      {IC[name ?? ""] ?? IC.dot}
    </svg>
  );
}

export function BackChevron() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M15 5l-7 7 7 7" />
    </svg>
  );
}
